import React, { useState } from "react";
import { Sidebar } from "primereact/sidebar";
import { Dialog } from "primereact/dialog";
import { Image } from "primereact/image";
import "./news-modal.scss";

export interface NewsItem {
  id?: string | number;
  ID?: string | number;
  newsId?: string | number;
  title: string;
  subtitle?: string;
  image?: string;
  imageUrl?: string;
  description?: string;
  newsDescription?: string;
  imageFileName?: string;
  containerName?: string;
  isActive?: boolean;
  createdBy?: number;
  createdByName?: string;
  createdDate?: string;
  features?: string[];
  cta?: {
    label: string;
    description: string;
  };
  size?: 'large' | 'medium' | 'small';
}

interface NewsModalProps {
  visible: boolean;
  onHide: () => void;
  newsItems?: NewsItem[];
  singleMode?: boolean;
}

const NewsModal: React.FC<NewsModalProps> = ({
  visible,
  onHide,
  newsItems = [],
  singleMode = false,
}) => {
  const [selectedNews, setSelectedNews] =
    useState<NewsItem | null>(null);

// Show only active news
const activeNews = newsItems.filter(item => item.isActive === true);

// Handle single / multiple mode
const displayItems = singleMode
  ? activeNews.slice(0, 1)
  : activeNews;


  /**
   * Get image URL with fallback support
   */
  const getImageUrl = (item: NewsItem): string => {
  return item.imageUrl || item.image || "";
};


  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);

  return (
    <>
      {/* ================= SIDEBAR ================= */}
      <Sidebar
        visible={visible}
        onHide={onHide}
        position="left"
        className="news-sidebar"
        modal
      >
        <div className="news-scroll">
          <div className="news-grid">
            {displayItems.map((item, index) => (
              <div
                key={item.ID || item.id || item.newsId}
                className={`news-grid-item ${
                  index === 0 ? "large" : ""
                }`}
                onClick={() => setSelectedNews(item)}
              >
                <div className="sidebar-item-image-wrapper">
                  <img
                    src={getImageUrl(item)}
                    alt={item.title}
                    className="sidebar-item-image"
                  />
                </div>

                <div className="sidebar-item-title">
                  <h4>{item.title}</h4>
                  {item.subtitle && (
                    <p className="sidebar-item-subtitle">
                      {item.subtitle}
                    </p>
                  )}
                
                 {item.createdDate && (
                    <p className="sidebar-item-date">
                        <span className="published-label">Published on:</span>&nbsp;
                        {new Date(item.createdDate).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        })}
                    </p>
                    )}

                </div>
              </div>
            ))}
          </div>
        </div>
      </Sidebar>

      {/* ================= DETAILS DIALOG ================= */}
      <Dialog
        visible={!!selectedNews}
        onHide={() => setSelectedNews(null)}
        modal
        style={{ width: "720px", maxWidth: "96vw" }}
        header={selectedNews?.title}
      >
        {selectedNews && (
          <div className="news-detail-wrapper">
            {/* IMAGE */}
            <Image
              src={getImageUrl(selectedNews)}
              alt={selectedNews.title}
              preview
              width="100%"
               onShow={() => setIsImagePreviewOpen(true)}
               onHide={() => setIsImagePreviewOpen(false)}
            />
            {!isImagePreviewOpen && (
            <>
            {/* SUBTITLE */}
            {selectedNews.subtitle && (
              <p className="news-detail-subtitle">
                {selectedNews.subtitle}
              </p>
            )}

            {/* DESCRIPTION ✅ FIX */}
            {(selectedNews.newsDescription || selectedNews.description) && (
              <p className="news-detail-description">
                {selectedNews.newsDescription || selectedNews.description}
              </p>
            )}

            {/* FEATURES */}
            {selectedNews.features && (
              <ul className="news-detail-features">
                {selectedNews.features.map((f, idx) => (
                  <li key={idx}>{f}</li>
                ))}
              </ul>
            )}

            {/* CTA */}
            {selectedNews.cta && (
              <div className="news-detail-cta">
                <strong>{selectedNews.cta.label}</strong>
                <p>{selectedNews.cta.description}</p>
              </div>
            )}
            
            </>
            )}
          </div>

        )}
      </Dialog>
    </>
  );
};

export default NewsModal;
